import { TextField, styled } from '@mui/material';

export const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: `${theme.shape.borderRadius * 11.2}px`,
  width: '100%',
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
}));

export const StyledInputBase = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: `${theme.shape.borderRadius * 11.2}px`,
  },
  '& .MuiInputBase-root': {
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
}));

export const SuggestionsContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  borderRadius: `${theme.shape.borderRadius * 1.6}px`,
  zIndex: theme.zIndex.appBar + 1,
  overflow: 'hidden',
  width: '100%',
}));
